import toast from "react-hot-toast";

export const notify = (message: string) => toast(message);
